// extracted by mini-css-extract-plugin
export default {"root":"MgxgLb4I9n5Z8rhD6axD","playIcon":"Yv21Sw3ygnnNnxdVBOYc","closeButton":"FnoeC1v_FKBXAy47UXgs","placeholderAnimate":"qGEXEZe8YA7CKGhIyYTj"};